
const i18nResources = {
    en: {
        translation: {
            "":"",

            "Program name":"Pano WEB",

            "File Category":"Type",

            "EditVP":"Rename",
            "AddVP":"Add",
            "ImproperImageAR":"Improper image aspect ratio (not 2:1)",
        }
    },
    hu: {
        translation: {
            "":"",

            "Program name":"Pano WEB",
            "administrator":"adminisztrátor",
            "Administrator":"Adminisztrátor",
            "Project manager":"Projekt szerkesztő",

            "User":"Felhasználók",
            "Project":"Projektek",
            "Assigned projects":"Engedélyezet projektek",

            "Add user":"Új felhasználó",
            "Assign to projects":"Projektek engedélyezése",
            "Login":"Bejelentkezés",
            "Password":"Jelszó",
            "Sign in":"Bejelentkezés",
            "Forgot password":"Elfelejtett jelszó",
            "Error":"Hiba",
            "Email name is required":"Az email megadása kötelező",
            "Enter your password":"A jelszó megadása kötelező",
            "Something magical has happened":"Megtörtént az elképzelhetelen",
            "Network error":"Hálózati kommunikációs hiba",
            "Unknown user":"Ismeretlen felhasználó",
            "Password invalid":"Hibás jelszó",
            "Your account is suspended":"Letíltott felhasználó",
            "You have no right to use builder tool":"Önnek nincs jogosultsága a használathoz",


            "Are you sure?":"Biztos benne?",
            "Confirm delete":"Törlés megerősítése",
            "Add project":"Új projekt",
            "Properties":"Jellemzők",
            "Delete":"Törlés",
            "Edit":"Szerkesztés",
            "Add":"Új",
            "No data":"(nincs)",
            "Name":"Név",
            "Start date":"Kezdés dátuma",
            "End date":"Befejezés dátuma",

            "Select projects":"Projektek",

            "File Category":"Típus",
            "Type":"Típus",
            "Back":"Vissza",
            "Date":"Dátum",
            "Viewpoint":"Nézőpont",
            "Reload":"Frissítés",
            "Assign to viewpoint":"Nézőponthoz rendelés",
            "Info":"Infó",
            "No panoramic image selected":"Nincs panorámakép kiválsztva",
            "No file selected":"Nincs fájl kiválsztva",
            "NeedTwoPanoSelectedAtThisVP":"Válasszon ki két, ugyan ahhoz a nézőponthoz tartozó panoráma képet!",

            "EditVP":"Átnevezés",
            "AddVP":"Új nézőpont",
            "DeleteVP":"Törlés",
            "EditOrientation":"Alaprajzi főirány",
            "EditNavi":"Navigálási távolság",
            "Zoom extents":"Teljes nézet",
            "Existing viewpoint":"Ilyen névvel már van nézőpont",

            "ImproperImageAR":"Nem megfelelő képarány (nem 2:1)",
            "Less than two panoramic images at this vp": "A funkció használatához legalább két panoráma fotóval rendelkező nézőpont szükséges.",

            "Coords":"Koordináta",

            "AlignPano":"Panorámaképek egymáshoz igazítása",
            "AlignFirstPano":"Panorámakép első iránybaigazítás",
            "Edit viepoints":"Nézőpontok szerkesztése",
            "Preview":"Kiterített előnézet",
            "Panoramic preview":"Panoráma előnézet",
        }
    }
};

export default i18nResources;